import TargetsMap from "./TargetsMap";

export default TargetsMap;
